import * as React from 'react';

import { NotFound as NotFoundPage } from 'bundles/common/components/withNotFound';
import { InternalServerError } from 'bundles/ssr/lib/errors/directives';
import inServerContext from 'bundles/ssr/util/inServerContext';

const InternalError = ({ pathname }: { pathname: string }) => {
  // If on server, serve a true 500 (edge will handle rendering internal server error page).
  if (inServerContext) {
    throw new InternalServerError(pathname);
  } else {
    // We don't have a component for internal errors, default to showing not found.
    return <NotFoundPage />;
  }
};

export default InternalError;
